import React from "react";
import { Mail } from "lucide-react";
import "./Contact.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useEffect } from "react";

export default function Contact() {
    useEffect(() => {
        document.title = "Contact Us | Brandly"; 
    }, []);
  return (
    <>
    <Navbar/>
    <div className="contact-container">
      <main className="contact-content">
        <Mail size={40} color="#0b65c3" />
        <h1>Contact Us</h1>
        <p>
          For any inquiries, reach us at:
        </p>
        <a href="mailto:hi@hevalabs.com" className="contact-email">
          hi@hevalabs.com
        </a>
      </main>
    </div>
    <Footer/>
    </>
    

  );
}
